import React, { useEffect, useRef } from "react";
import SkinPlaceholder from "../../../../assets/images/SkinPlaceholder.png";
import { Form, FormInstance } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "../../../../componets/Buttons";

interface propsInterface {
  imgUrl: string | undefined;
  form: FormInstance;
  setSkinPreview: Function;
}

const _ThumbnailGenerator = ({ form, imgUrl, setSkinPreview }: propsInterface ) => {
  const typeIdValue   = Form.useWatch('type_id', form);
  const textureValue  = Form.useWatch('texture', form);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const canvasCtxRef = React.useRef<CanvasRenderingContext2D | null>(null);

  useEffect(() => {
    if (canvasRef.current) {
      canvasCtxRef.current = canvasRef.current.getContext('2d');
    }
  }, []);

  useEffect(() => {
    if (textureValue) {
      resetCanvas();
      loadImage(URL.createObjectURL(textureValue), (e) => {
        onLoadSkin(e);
        setThumbnail();
      });
    } else if (imgUrl) {
      resetCanvas();
      loadImage(imgUrl, onLoadSkin);
    }
  }, [textureValue, imgUrl, typeIdValue]);

  function resetCanvas() {
    const ctx = canvasCtxRef.current;

    if(ctx) {
      ctx.clearRect(0, 0, 330, 330);
    }
  }

  function setThumbnail() {
    if (!canvasRef.current) {
      return;
    }

    canvasRef.current.toBlob((blob) => {
      if (!blob) {
        return;
      }

      const file = new File(
        [blob],
        `skin_thumbnail_${Date.now()}.png`,
        { type: "image/png" }
      );

      if (canvasRef.current) {
        setSkinPreview(canvasRef.current.toDataURL());
      }

      form.setFieldValue( 'thumbnail', file);
    }, 'image/png');
  }

  function loadImage(src, onload) {
    const img = new Image();

    img.onload = () => onload(img);
    img.src = src;
    img.crossOrigin = 'anonymous';

    return img;
  }

  function onLoadSkin(img) {
    const ctx = canvasCtxRef.current;

    if(ctx && img) {
      switch (typeIdValue) {
        case 0:
          addPants(img, ctx);
          break;
        case 1:
          addShirt(img, ctx);
          break;
        case 2:
          addTShirt(img, ctx);
          break;
      }
    }
  }

  function addPants(img, ctx) {
    ctx.drawImage(img, 217, 355, 64, 128, 101, 197, 63.5, 128);
    ctx.drawImage(img, 308, 355, 64, 128, 165.5, 197, 63.5, 128);
    ctx.drawImage(img, 231, 74, 128, 128, 101, 68, 128, 128);
  }

  function addTShirt(img, ctx) {
    ctx.drawImage(img, 101, 68, 128, 128);
  }

  function addShirt(img, ctx) {
    ctx.drawImage(img, 217, 355, 64, 128, 36, 68, 64, 128);
    ctx.drawImage(img, 308, 355, 64, 128, 230, 68, 64, 128);
    ctx.drawImage(img, 231, 74, 128, 128, 101, 68, 128, 128);
  }

  return (
    <div className='v-mb-10' style={{ display: 'flex', justifyContent: 'flex-start' }}>
      <canvas
        width="330"
        height="330"
        ref={canvasRef}
        style={{ background: `url(${SkinPlaceholder}) no-repeat center center` }}
      />

      <Button
        icon={ReloadOutlined}
        onClick={setThumbnail}
        title='Generate Thumbnail'
      />
    </div>
  )
}

export default _ThumbnailGenerator;
